import { exportPDF } from "@api/stores/employeeCosts/exportPDF/api";
import { stats } from "@api/stores/employeeCosts/stats/api";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IEmployeeCostsDto,
  IEmployeeCostsGetAllParams,
  IEmployeeCostsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IEmployeeCostsResponse>>,
  IPathBaseParam,
  IPaginationParams & IEmployeeCostsGetAllParams
>("stores.employeeCosts");
const postApis = createPostApi<
  IApiResponse<IEmployeeCostsResponse>,
  IPathBaseParam,
  IEmployeeCostsDto
>("stores.employeeCosts");
const getApis = createGetApi<
  IApiResponse<IEmployeeCostsResponse>,
  IPathByIdParam,
  object
>("stores.employeeCosts");
const patchApis = createPatchApi<
  IApiResponse<IEmployeeCostsResponse>,
  IPathByIdParam,
  IEmployeeCostsDto
>("stores.employeeCosts");
const deleteApis = createDeleteApi<
  IApiResponse<IEmployeeCostsResponse>,
  IPathByIdParam
>("stores.employeeCosts");

export const employeeCosts = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
  stats,
  exportPDF,
};
